// extracted by mini-css-extract-plugin
var _1 = "ListNumber_numberText__4c6fe";
export { _1 as "numberText" }
